import {Model, ModelMixin} from '../common/model.class';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class User extends ModelMixin() implements Model<User> {

    TYPE = User;

    id?: string;
    remoteId?: string;
    name: {
        firstName?: string,
        middleName?: string,
        lastName?: string
    } = {};
    email1?: string;
    emailChange: {
        email?: string
    } = {};
    alias?: string;
    sex?: string;
    notifyUser?: boolean;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/user/user.model.ts